import { supabase } from './supabase'

/**
 * Get active sessions for user with security status
 */
export const getActiveSessions = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) return []

    // Use the enhanced function that includes security status
    const { data, error } = await supabase.rpc('get_active_sessions_with_security', {
      user_id_param: user.id,
    })

    if (error) {
      // Fallback to basic query if function doesn't exist
      const { data: fallbackData, error: fallbackError } = await supabase
        .from('user_sessions')
        .select('*')
        .eq('user_id', user.id)
        .eq('is_active', true)
        .gt('expires_at', new Date().toISOString())
        .order('last_activity_at', { ascending: false })

      if (fallbackError) throw fallbackError
      return fallbackData || []
    }

    return data || []
  } catch (error) {
    console.error('Error fetching active sessions:', error)
    return []
  }
}

/**
 * Revoke a session
 */
export const revokeSession = async (sessionId) => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) throw new Error('User not authenticated')

    const { error } = await supabase
      .from('user_sessions')
      .update({ is_active: false })
      .eq('id', sessionId)
      .eq('user_id', user.id)

    if (error) throw error
    return { success: true }
  } catch (error) {
    console.error('Error revoking session:', error)
    throw error
  }
}

/**
 * Revoke all other sessions
 */
export const revokeAllOtherSessions = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) throw new Error('User not authenticated')

    const { error } = await supabase
      .from('user_sessions')
      .update({ is_active: false })
      .eq('user_id', user.id)
      .neq('session_token', 'current') // Would need current session token

    if (error) throw error
    return { success: true }
  } catch (error) {
    console.error('Error revoking all sessions:', error)
    throw error
  }
}

/**
 * Update session activity
 */
export const updateSessionActivity = async (sessionToken) => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) return

    await supabase
      .from('user_sessions')
      .update({ last_activity_at: new Date().toISOString() })
      .eq('session_token', sessionToken)
      .eq('user_id', user.id)
  } catch (error) {
    console.error('Error updating session activity:', error)
  }
}

